(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

  const moveToBusinessDay = (date) => {
    const result = new Date(date);
    while (isWeekend(result)) result.setDate(result.getDate() + 1);
    return result;
  };

  const addDays = (date, amount, skipWeekends) => {
    const result = new Date(date);
    let remaining = Math.max(0, Number(amount) || 0);

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (!skipWeekends || !isWeekend(result)) remaining -= 1;
    }

    return skipWeekends ? moveToBusinessDay(result) : result;
  };

  const getOrderCutoff = (now, hour, minute, skipWeekends) => {
    let target = new Date(now);
    target.setHours(hour, minute, 0, 0);

    if (skipWeekends) target = moveToBusinessDay(target);

    if (target <= now) {
      target.setDate(target.getDate() + 1);
      if (skipWeekends) target = moveToBusinessDay(target);
      target.setHours(hour, minute, 0, 0);
    }

    return target;
  };

  const formatWeekday = (date) => {
    const locale = document.documentElement.lang || 'fr-FR';
    const value = new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(date);
    return value.charAt(0).toUpperCase() + value.slice(1);
  };

  const formatLongDate = (date) => {
    const locale = document.documentElement.lang || 'fr-FR';
    return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(date);
  };

  const updateTimeline = (timeline) => {
    const now = new Date();
    const countdownEnabled = timeline.dataset.countdownEnabled === 'true';
    const cutoffHour = Number(timeline.dataset.cutoffHour || 15);
    const cutoffMinute = Number(timeline.dataset.cutoffMinute || 0);
    const skipWeekends = timeline.dataset.skipWeekends === 'true';
    const target = getOrderCutoff(now, cutoffHour, cutoffMinute, skipWeekends);

    if (countdownEnabled) {
      const countdown = timeline.querySelector('[data-up-delivery-countdown-value]');
      if (countdown) {
        const remaining = Math.max(0, target.getTime() - now.getTime());
        const hours = Math.floor(remaining / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        countdown.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      }
    }

    const shippingValue = timeline.querySelector('[data-up-delivery-shipping-value]');
    if (!shippingValue) return;

    if (timeline.dataset.shippingMode === 'custom') {
      shippingValue.textContent = shippingValue.dataset.customValue || '';
      return;
    }

    const dispatchDays = Number(timeline.dataset.dispatchDays || 1);
    const shippingDate = addDays(target, dispatchDays, skipWeekends);
    shippingValue.textContent = formatWeekday(shippingDate);
  };

  const updateEstimate = (estimate) => {
    const now = new Date();
    const minDays = Number(estimate.dataset.minDays || 2);
    const maxDays = Math.max(minDays, Number(estimate.dataset.maxDays || 4));
    const skipWeekends = estimate.dataset.skipWeekends === 'true';
    const prefix = estimate.dataset.prefix || 'Livré entre le';
    const minimumDate = addDays(now, minDays, skipWeekends);
    const maximumDate = addDays(now, maxDays, skipWeekends);
    estimate.textContent = `${prefix} ${formatLongDate(minimumDate)} et le ${formatLongDate(maximumDate)}`;
  };

  const updateAll = () => {
    document.querySelectorAll('[data-up-delivery-timeline]').forEach(updateTimeline);
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-up-delivery-estimate]').forEach(updateEstimate);
    scope.querySelectorAll('[data-up-delivery-timeline]').forEach(updateTimeline);
  };

  if (!window.upProductDeliveryTimer) {
    window.upProductDeliveryTimer = window.setInterval(updateAll, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
